import {
    SET_FLEET_DISPOSITION_SAVE
} from "./FleetDispositionSaveType"

const initialState = {
    fleetDispositionValue: null
}


const reducer = (state = initialState, action: any) => {
    if (action.type === SET_FLEET_DISPOSITION_SAVE) {
        return {
            ...state,
            fleetDispositionValue: action.fleetDispositionValue,
        };
    }
    else {
        return state;
    }
};

export default reducer;